const ta = {
  "भाजपा सदस्यता अभियान - 2024": "பாஜக உறுப்பினர் சேர்க்கை பிரச்சாரம் - 2024",
  "Select Language": "மொழியைத் தேர்ந்தெடுக்கவும்",
  Next: "அடுத்து",
  "Enter your mobile number": "உங்கள் மொபைல் எண்ணை உள்ளிடவும்",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "நான் விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்றுக்கொள்கிறேன், தொடர்வதன் மூலம், தானாக முன்வந்து பிஜேபியில் உறுப்பினராவதற்கு சம்மதிக்கிறேன்",
  "Get OTP": "OTP பெறவும்",
  "Terms and Conditions": "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
  "You must tick the box to continue, as it is mandatory.":
    "தொடர்வதற்கு நீங்கள் பெட்டியை டிக் செய்ய வேண்டும், ஏனெனில் இது கட்டாயமாகும்.",
  "Okay, Got it": "சரி, புரிந்தது",
  "Get OTP": "OTP பெறவும்",
  "Enter OTP": "OTP ஐ உள்ளிடவும்",
  "Resend OTP": "OTP ஐ மீண்டும் அனுப்பவும்",
  Continue: "தொடரவும்",
  "Fill details": "விவரங்களை நிரப்பவும்",
  "Upload Photo": "புகைப்படத்தைப் பதிவேற்றவும்",
  "Profile Photo": "சுயவிவரப் புகைப்படம்",
  "Mobile number": "மொபைல் எண்",
  "Mrs.": "திருமதி",
  "Mr.": "திரு",
  Ms: "திருமதி",
  "Full Name*": "முழு பெயர் *",
  "D.O.B": "D.O.B",
  Age: "வயது",
  Gender: "பாலினம்",
  Female: "பெண்",
  Male: "ஆண்",
  Other: "மற்றவை",
  "Email Id": "மின்னஞ்சல் ஐடி",
  "Add address": "முகவரியைச் சேர்க்கவும்",
  "House/ Flat/ Floor No.": "வீடு/ பிளாட்/ மாடி எண்.",
  "Current address PIN code": "தற்போதைய முகவரி பின் குறியீடு",
  "District*": "மாவட்டம்*",
  State: "மாநிலம்",
  "Assembly constituency (AC)": "சட்டமன்ற தொகுதி (ஏசி)",
  "Tell us about your location":
    "உங்கள் இருப்பிடத்தைப் பற்றி எங்களிடம் கூறுங்கள்",
  "It will assist us in locating other members in your area.":
    "உங்கள் பகுதியில் உள்ள மற்ற உறுப்பினர்களைக் கண்டறிய இது எங்களுக்கு உதவும்.",
  "Your address as fetched": "உங்கள் முகவரி பெறப்பட்டது",
  "Referral code": "பரிந்துரை குறியீடு",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "மேலே கொடுக்கப்பட்டுள்ள தகவல்கள் சரியானவை என்றும் எந்த தவறும் இல்லை என்றும் சான்றளிக்கிறேன். மேலும் அனைத்து தகவல்தொடர்புகளும் மேலே கொடுக்கப்பட்ட விவரங்களில் செய்யப்படும் என்பதை நான் அறிவேன்",
  Save: "சேமிக்கவும்",
  Select: "தேர்ந்தெடு",
  Camera: "கேமரா",
  or: "அல்லது",
  Gallery: "தொகுப்பு",
  "Support format : Jpeg, Png, Pdf": "ஆதரவு வடிவம்: Jpeg, Png, Pdf",
  Cancel: "ரத்து செய்",
  "Select location": "இருப்பிடத்தைத் தேர்ந்தெடுக்கவும்",
  "Provide location": "இடம் வழங்கவும்",
  "Search results": "தேடல் முடிவுகள்",
  "Search for a building, street name or..": "கட்டிடம், தெரு பெயர் அல்லது..",
  "Your address as fetched": "உங்கள் முகவரி பெறப்பட்டது",
  "Locate me": "என்னைக் கண்டுபிடி",
  "Confirm location": "இருப்பிடத்தை உறுதிப்படுத்தவும்",
  "Congratulations !": "வாழ்த்துகள் !",
  "Your primary Id is -": "உங்கள் முதன்மை ஐடி -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "Bjp.org/membership இல் உள்நுழைந்து உங்கள் தரவை மேம்படுத்தவும், உங்கள் அடையாள அட்டையை அணுகவும் மற்றும் முதன்மை உறுப்பினர்களாக சேர மற்றவர்களைப் பார்க்கவும்.",
  "ID CARD": "அடையாள அட்டை",
  "You can download your generated ID Card":
    "நீங்கள் உருவாக்கிய அடையாள அட்டையை பதிவிறக்கம் செய்யலாம்",
  Download: "பதிவிறக்கவும்",
  "Go to dashboard": "டாஷ்போர்டுக்குச் செல்லவும்",
  "View your profile": "உங்கள் சுயவிவரத்தைப் பார்க்கவும்",
  "Refer and add member": "பரிந்துரைத்து உறுப்பினரைச் சேர்க்கவும்",
  Share: "பகிரவும்",
  "To update your additional details and refer more member, please click here.":
    "உங்கள் கூடுதல் விவரங்களைப் புதுப்பிக்கவும் மேலும் உறுப்பினர்களைப் பார்க்கவும், தயவுசெய்து இங்கே கிளிக் செய்யவும்.",
  "Bharatiya Janata Party": "பாரதிய ஜனதா கட்சி",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6A, தீன்தயாள் உபாத்யாயா மார்க், புது தில்லி - 110002",
  Name: "பெயர்",
  "Membership Number": "உறுப்பினர் எண்",
  "QR Code": "QR குறியீடு",
  "Please select a year between 1930 and 2006.":
    "தயவுசெய்து 1930 மற்றும் 2006 க்கும் இடையில் ஒரு ஆண்டை தேர்வு செய்யவும்.",
  "Please enter a valid email address.":
    "தயவுசெய்து சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
  "Please enter 6-digit PIN code.": "6 இலக்க PIN குறியீட்டை உள்ளிடவும்.",
  "10-digit mobile number.": "10 இலக்க மொபைல் எண்.",
  "Please enter a 10-digit mobile number.": "10 இலக்க மொபைல் எண்ணை உள்ளிடவும்.",
  "Please enter your name.": "தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்.",
  "I pledge and willing to receive regular updates from BJP":
    "நீங்கள் குறைந்தபட்சம் 18 வயதிற்கும் மேல் இருக்க வேண்டும்.",
  "Get Verification Code": "சரிபார்ப்பு குறியீடு பெறவும்",
  "Enter Verification Code": "சரிபார்ப்பு குறியீட்டை நுழையவும்",
  "Resend Verification Code": "சரிபார்ப்பு குறியீட்டை மீண்டும் அனுப்பவும்",
  "Provide Details": "விவரங்களை வழங்கவும்",
  Upload: "பதிவேற்றவும்",
  Ok: "சரி",
  Calendar: "காலண்டர்",
  "Full Address": "முழு முகவரி",
  "Privacy policy": "தனியுரிமை கொள்கை",
  Disclaimer: "மறுப்பு",
  "Contact us": "எங்களை அணுகவும்",
  Save: "சேமிக்கவும்",
  "Your primary member ID": "உங்கள் முதன்மை உறுப்பினர் ஐடி",
  "Membership Card": "உறுப்பினர் அட்டை",
  "Your Unique Referral code": "உங்கள் தனித்துவமான முன்மொழியக் குறியீடு",
  "Invite and add member": "அழைக்கவும் மற்றும் உறுப்பினரைச் சேர்க்கவும்",
  Share: "பகிரவும்",
  "Click below to add more details, donate and add other members to BJP":
    "மேலும் விவரங்களைச் சேர்க்க, நன்கொடை அளிக்க மற்றும் பாஜகவில் மற்ற உறுப்பினர்களைச் சேர்க்க கீழே கிளிக் செய்யவும்.",
  "Update your details": "உங்கள் விவரங்களைப் புதுப்பிக்கவும்",
  "Add Referral Details": "பரிந்துரை விவரங்களைச் சேர்க்கவும்",
  "Referred by (name)": "பரிந்துரை செய்தவர் (மொபைல் எண்கள்)",
  "Referred by (mobile number)": "பரிந்துரை செய்தவர் (மொபைல் எண்கள்)",
  Capture: "புகைப்படம் எடுக்கவும்",
  "Close Camera": "",
  Uploading: "பதிவேற்றுகிறது",
  "Your Unique Referral Link": "உங்கள் தனிப்பட்ட பரிந்துரை இணைப்பு",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "இன்றைய அதிகபட்ச OTP முயற்சிகளை அடைந்துவிட்டீர்கள். நாளை மீண்டும் முயற்சிக்கவும்",
  Miss: "திருமதி",
  "Full Name": "",
  "OTP limit reached for today. Please try again tomorrow": "",
  ": is not a Primary Member, Only Primary Members can refer": "",
  "Please enter valid fullname": "சரியான முழுப்பெயரை உள்ளிடவும்",
  Upload: "பதிவேற்றவும்",
};

export default ta;
